import { getItemById } from '../ducks/data'

export const addRelatedBindings = (bindings, state, app) => {
  let newBindings = {}

  for (let key of Object.keys(bindings)) {
    let { datasources } = app
    let [datasourceId, tableId] = key.split('.')

    if (datasources[datasourceId].tables) {
      let table = datasources[datasourceId].tables[tableId]

      let referenceFields = Object.keys(table.fields).filter(
        fieldId => table.fields[fieldId].type.type === 'belongsTo'
      )

      let record = getItemById(state, tableId, bindings[key])

      referenceFields.map(fieldId => {
        let { tableId } = table.fields[fieldId].type
        let key = `${datasourceId}.${tableId}`

        if (!newBindings[key]) {
          newBindings[key] = record[fieldId]
        }
      })
    }
  }

  return { ...newBindings, ...bindings }
}
